<template>
  <v-container>
    <v-row>
      <v-col class="mb-2">
        <ProfileInformation />

        <ProfileCard
          v-if="employment.items?.length"
          :item="employment"
        />

        <ProfileCard
          v-for="(item, index) in mock"
          :key="index"
          :item="item"
        />

        <ProfileCard
          v-if="certifications.items?.length"
          :item="certifications"
        />
        <ProfileCard
          v-if="credentials.items?.length"
          :item="credentials"
        />
        <ProfileCard
          v-if="education.items?.length"
          :item="education"
        />
        <ProfileCard
          v-if="trainings.items?.length"
          :item="trainings"
        />
        <ProfileCard
          v-if="leadership.items?.length"
          :item="leadership"
        />
        <ProfileCard
          v-if="volunteer.items?.length"
          :item="volunteer"
        />
        <ProfileCard
          v-if="affiliations.items?.length"
          :item="affiliations"
        />
      </v-col>

      <v-col
        v-if="false"
        class="space-y"
        cols="4"
      >
        <ProfileInvitations />
        <ProfileConnections />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { useStore } from 'vuex';

import { formatDate as formatDateExact } from '@/shared/services/date-helper';
import ProfileCard from '@/manager/components/profile/ProfileCard.vue';
import ProfileConnections from '@/manager/components/profile/ProfileConnections.vue';
import ProfileInformation from '@/manager/components/profile/ProfileInformation.vue';
import ProfileInvitations from '@/manager/components/profile/ProfileInvitations.vue';

const store = useStore();
const employment = computed(() => ({
  title: 'Employment History',
  items: (store.state.profile?.employments || []).map((emp) => ({
    id: emp.id,
    icon: 'work',
    main: emp.title || emp.business_role || 'Position Not Specified',
    sub: emp.business_name,
    details: [
      [
        emp.start_date
          ? `${formatDateExact(emp.start_date, 'MMMM d, yyyy')} - ${emp.end_date ? formatDateExact(emp.end_date, 'MMMM d, yyyy') : 'Present'}`
          : 'Date Not Specified',
        emp.start_date && emp.end_date
          ? `${Math.floor((new Date(emp.end_date) - new Date(emp.start_date)) / (1000 * 60 * 60 * 24 * 30.44))} months`
          : emp.start_date
            ? `${Math.floor((new Date() - new Date(emp.start_date)) / (1000 * 60 * 60 * 24 * 30.44))} months`
            : '',
      ],
    ],
  })),
}));

const certifications = ref({ title: 'Certifications', items: [] });
const credentials = ref({ title: 'Credentials', items: [] });
const education = ref({ title: 'Education', items: [] });
const trainings = ref({ title: 'Trainings', items: [] });
const leadership = ref({ title: 'Leadership', items: [] });
const volunteer = ref({ title: 'Volunteer', items: [] });
const affiliations = ref({ title: 'Affiliations', items: [] });
const mock = [
  {
    title: 'Certifications',
    items: [
      {
        icon: 'shield',
        main: 'CPR',
        sub: 'American Red Cross',
        details: [['Issued August 2023', 'Expires August 2025'], ['Certification ID 123456']],
      },
    ],
  },
  {
    title: 'Credentials',
    items: [
      {
        icon: 'card_membership',
        main: 'Child Development Associate (CDA) Credential',
        sub: 'American Montessori Society',
        details: [['Issued August 2023', 'Expires August 2025'], ['Credential ID 123456']],
      },
    ],
  },
  {
    title: 'Education',
    items: [
      {
        icon: 'school',
        main: 'Bachelor of Science in Early Childhood Education',
        sub: 'University of Texas',
        details: [['Graduated May 2019']],
      },
    ],
  },
  {
    title: 'Trainings',
    items: [
      {
        icon: 'cast_for_education',
        main: 'Culturally Responsive Early Learning & Teaching',
        sub: 'American Montessori Society',
        details: [['Completed June 2024']],
      },
    ],
  },
  {
    title: 'Affiliations',
    items: [
      {
        icon: 'groups',
        main: 'Bachelor of Science in Early Childhood Education',
        sub: 'University of Texas',
        details: [['Graduated May 2019']],
      },
    ],
  },
];
</script>
